module.exports = __webpack_public_path__ + "static/media/16.09cd1fc4.jpg";